import {
    ArrowDownIcon as ArrowDownIconMicro,
    ArrowDownRightIcon as ArrowDownRightIconMicro,
    ArrowPathIcon as ArrowPathIconMicro,
    ArrowRightIcon as ArrowRightIconMicro,
    ArrowTrendingUpIcon as ArrowTrendingUpIconMicro,
    ArrowUpIcon as ArrowUpIconMicro,
    ArrowUpRightIcon as ArrowUpRightIconMicro,
    BanknotesIcon as BanknotesIconMicro,
    Bars3Icon as Bars3IconMicro,
    BeakerIcon as BeakerIconMicro,
    BellIcon as BellIconMicro,
    BoltIcon as BoltIconMicro,
    BriefcaseIcon as BriefcaseIconMicro,
    BuildingOfficeIcon as BuildingOfficeIconMicro,
    CalendarIcon as CalendarMicro,
    ChatBubbleLeftIcon as ChatBubbleLeftIconMicro,
    ChatBubbleOvalLeftIcon as ChatBubbleOvalLeftIconMicro,
    CheckBadgeIcon as CheckBadgeIconMicro,
    CheckCircleIcon as CheckCircleIconMicro,
    CheckIcon as CheckIconMicro,
    ChevronDownIcon as ChevronDownIconMicro,
    ChevronLeftIcon as ChevronLeftIconMicro,
    ChevronRightIcon as ChevronRightIconMicro,
    ChevronUpDownIcon as ChevronUpDownIconMicro,
    ChevronUpIcon as ChevronUpIconMicro,
    CircleStackIcon as CircleStackIconMicro,
    ClockIcon as ClockIconMicro,
    ClipboardDocumentCheckIcon as ClipboardDocumentCheckIconMicro,
    ClipboardDocumentListIcon as ClipboardDocumentListIconMicro,
    ClipboardIcon as ClipboardIconMicro,
    Cog6ToothIcon as Cog6ToothIconMicro,
    DocumentChartBarIcon as DocumentChartBarIconMicro,
    DocumentDuplicateIcon as DocumentDuplicateIconMicro,
    DocumentMagnifyingGlassIcon as DocumentMagnifyingGlassIconMicro,
    ArrowDownTrayIcon as DownloadIconMicro,
    EnvelopeIcon as EnvelopeIconMicro,
    ExclamationCircleIcon as ExclamationCircleIconMicro,
    ExclamationTriangleIcon as ExclamationTriangleIconMicro,
    EyeIcon as EyeMicro,
    FlagIcon as FlagIconMicro,
    GlobeAltIcon as GlobeAltIconMicro,
    GlobeAmericasIcon as GlobeAmericasIconMicro,
    GlobeAsiaAustraliaIcon as GlobeAsiaAustraliaIconMicro,
    GlobeEuropeAfricaIcon as GlobeEuropeAfricaIconMicro,
    HandThumbDownIcon as HandThumbDownIconMicro,
    HandThumbUpIcon as HandThumbUpIconMicro,
    HashtagIcon as HashtagIconMicro,
    InformationCircleIcon as InformationCircleIconMicro,
    EllipsisVerticalIcon as KebabIconMicro,
    LinkIcon as LinkIconMicro,
    LinkSlashIcon as LinkSlashIconMicro,
    ListBulletIcon as ListBulletIconMicro,
    LockClosedIcon as LockClosedIconMicro,
    LockOpenIcon as LockOpenIconMicro,
    MagnifyingGlassIcon as MagnifyingGlassIconMicro,
    MagnifyingGlassMinusIcon as MagnifyingGlassMinusIconMicro,
    MagnifyingGlassPlusIcon as MagnifyingGlassPlusIconMicro,
    MapIcon as MapIconMicro,
    MicrophoneIcon as MicrophoneIconMicro,
    MinusCircleIcon as MinusCircleIconMicro,
    MinusIcon as MinusIconMicro,
    PaperAirplaneIcon as PaperAirplaneIconMicro,
    PaperClipIcon as PaperClipIconMicro,
    PencilIcon as PencilIconMicro,
    PencilSquareIcon as PencilSquareIconMicro,
    PhotoIcon as PhotoIconMicro,
    PlusCircleIcon as PlusCircleIconMicro,
    PlusIcon as PlusIconMicro,
    QuestionMarkCircleIcon as QuestionMarkCircleMicro,
    ScaleIcon as ScaleIconMicro,
    ShareIcon as ShareIconMicro,
    SparklesIcon as SparklesIconMicro,
    StarIcon as StarIconMicro,
    StopIcon as StopIconMicro,
    SunIcon as SunIconMicro,
    TrashIcon as TrashIconMicro,
    TrophyIcon as TrophyIconMicro,
    ArrowUpTrayIcon as UploadIconMicro,
    UserCircleIcon as UserCircleIconMicro,
    UserGroupIcon as UserGroupIconMicro,
    UserIcon as UserIconMicro,
    XCircleIcon as XCircleIconMicro,
    XMarkIcon as XMarkIconMicro,
} from '@heroicons/vue/16/solid'
import {
    ArrowDownIcon as ArrowDownIconMini,
    ArrowDownRightIcon as ArrowDownRightIconMini,
    ArrowPathIcon as ArrowPathIconMini,
    ArrowRightIcon as ArrowRightIconMini,
    ArrowTrendingUpIcon as ArrowTrendingUpIconMini,
    ArrowUpIcon as ArrowUpIconMini,
    ArrowUpRightIcon as ArrowUpRightIconMini,
    BanknotesIcon as BanknotesIconMini,
    Bars3Icon as Bars3IconMini,
    BeakerIcon as BeakerIconMini,
    BellIcon as BellIconMini,
    BoltIcon as BoltIconMini,
    BriefcaseIcon as BriefcaseIconMini,
    BuildingOfficeIcon as BuildingOfficeIconMini,
    CalendarIcon as CalendarMini,
    ChatBubbleLeftIcon as ChatBubbleLeftIconMini,
    ChatBubbleOvalLeftIcon as ChatBubbleOvalLeftIconMini,
    CheckBadgeIcon as CheckBadgeIconMini,
    CheckCircleIcon as CheckCircleIconMini,
    CheckIcon as CheckIconMini,
    ChevronDownIcon as ChevronDownIconMini,
    ChevronLeftIcon as ChevronLeftIconMini,
    ChevronRightIcon as ChevronRightIconMini,
    ChevronUpDownIcon as ChevronUpDownIconMini,
    ChevronUpIcon as ChevronUpIconMini,
    CircleStackIcon as CircleStackIconMini,
    ClockIcon as ClockIconMini,
    ClipboardDocumentCheckIcon as ClipboardDocumentCheckIconMini,
    ClipboardDocumentListIcon as ClipboardDocumentListIconMini,
    ClipboardIcon as ClipboardIconMini,
    Cog6ToothIcon as Cog6ToothIconMini,
    DocumentChartBarIcon as DocumentChartBarIconMini,
    DocumentDuplicateIcon as DocumentDuplicateIconMini,
    DocumentMagnifyingGlassIcon as DocumentMagnifyingGlassIconMini,
    ArrowDownTrayIcon as DownloadIconMini,
    EnvelopeIcon as EnvelopeIconMini,
    ExclamationCircleIcon as ExclamationCircleIconMini,
    ExclamationTriangleIcon as ExclamationTriangleIconMini,
    EyeIcon as EyeMini,
    FlagIcon as FlagIconMini,
    GlobeAltIcon as GlobeAltIconMini,
    GlobeAmericasIcon as GlobeAmericasIconMini,
    GlobeAsiaAustraliaIcon as GlobeAsiaAustraliaIconMini,
    GlobeEuropeAfricaIcon as GlobeEuropeAfricaIconMini,
    HandThumbDownIcon as HandThumbDownIconMini,
    HandThumbUpIcon as HandThumbUpIconMini,
    HashtagIcon as HashtagIconMini,
    InformationCircleIcon as InformationCircleIconMini,
    EllipsisVerticalIcon as KebabIconMini,
    LinkIcon as LinkIconMini,
    LinkSlashIcon as LinkSlashIconMini,
    ListBulletIcon as ListBulletIconMini,
    LockClosedIcon as LockClosedIconMini,
    LockOpenIcon as LockOpenIconMini,
    MagnifyingGlassIcon as MagnifyingGlassIconMini,
    MagnifyingGlassMinusIcon as MagnifyingGlassMinusIconMini,
    MagnifyingGlassPlusIcon as MagnifyingGlassPlusIconMini,
    MapIcon as MapIconMini,
    MicrophoneIcon as MicrophoneIconMini,
    MinusCircleIcon as MinusCircleIconMini,
    MinusIcon as MinusIconMini,
    PaperAirplaneIcon as PaperAirplaneIconMini,
    PaperClipIcon as PaperClipIconMini,
    PencilIcon as PencilIconMini,
    PencilSquareIcon as PencilSquareIconMini,
    PhotoIcon as PhotoIconMini,
    PlusCircleIcon as PlusCircleIconMini,
    PlusIcon as PlusIconMini,
    QuestionMarkCircleIcon as QuestionMarkCircleMini,
    ScaleIcon as ScaleIconMini,
    ShareIcon as ShareIconMini,
    SparklesIcon as SparklesIconMini,
    StarIcon as StarIconMini,
    StopIcon as StopIconMini,
    SunIcon as SunIconMini,
    TrashIcon as TrashIconMini,
    TrophyIcon as TrophyIconMini,
    ArrowUpTrayIcon as UploadIconMini,
    UserCircleIcon as UserCircleIconMini,
    UserGroupIcon as UserGroupIconMini,
    UserIcon as UserIconMini,
    XCircleIcon as XCircleIconMini,
    XMarkIcon as XMarkIconMini,
} from '@heroicons/vue/20/solid'
import {
    ArrowDownIcon as ArrowDownIconOutline,
    ArrowDownRightIcon as ArrowDownRightIconOutline,
    ArrowPathIcon as ArrowPathIconOutline,
    ArrowRightIcon as ArrowRightIconOutline,
    ArrowTopRightOnSquareIcon as ArrowTopRightOnSquareIconOutline,
    ArrowTrendingUpIcon as ArrowTrendingUpIconOutline,
    ArrowUpIcon as ArrowUpIconOutline,
    ArrowUpRightIcon as ArrowUpRightIconOutline,
    BanknotesIcon as BanknotesIconOutline,
    Bars3Icon as Bars3IconOutline,
    BeakerIcon as BeakerIconOutline,
    BellIcon as BellIconOutline,
    BoltIcon as BoltIconOutline,
    BriefcaseIcon as BriefcaseIconOutline,
    BuildingOfficeIcon as BuildingOfficeIconOutline,
    CalendarIcon as CalendarOutline,
    ChartBarIcon as ChartBarIconOutline,
    ChartBarSquareIcon as ChartBarSquareIconOutline,
    ChartPieIcon as ChartPieIconOutline,
    ChatBubbleLeftIcon as ChatBubbleLeftIconOutline,
    ChatBubbleOvalLeftIcon as ChatBubbleOvalLeftIconOutline,
    CheckBadgeIcon as CheckBadgeIconOutline,
    CheckCircleIcon as CheckCircleIconOutline,
    CheckIcon as CheckIconOutline,
    ChevronDownIcon as ChevronDownIconOutline,
    ChevronLeftIcon as ChevronLeftIconOutline,
    ChevronRightIcon as ChevronRightIconOutline,
    ChevronUpDownIcon as ChevronUpDownIconOutline,
    ChevronUpIcon as ChevronUpIconOutline,
    CircleStackIcon as CircleStackIconOutline,
    ClockIcon as ClockIconOutline,
    ClipboardDocumentCheckIcon as ClipboardDocumentCheckIconOutline,
    ClipboardDocumentListIcon as ClipboardDocumentListIconOutline,
    ClipboardIcon as ClipboardIconOutline,
    Cog6ToothIcon as Cog6ToothIconOutline,
    DocumentChartBarIcon as DocumentChartBarIconOutline,
    DocumentDuplicateIcon as DocumentDuplicateIconOutline,
    DocumentIcon as DocumentIconOutline,
    DocumentMagnifyingGlassIcon as DocumentMagnifyingGlassIconOutline,
    ArrowDownTrayIcon as DownloadIconOutline,
    EnvelopeIcon as EnvelopeIconOutline,
    ExclamationCircleIcon as ExclamationCircleIconOutline,
    ExclamationTriangleIcon as ExclamationTriangleIconOutline,
    EyeIcon as EyeOutline,
    FlagIcon as FlagIconOutline,
    FunnelIcon as FunnelIconOutline,
    GlobeAltIcon as GlobeAltIconOutline,
    GlobeAmericasIcon as GlobeAmericasIconOutline,
    GlobeAsiaAustraliaIcon as GlobeAsiaAustraliaIconOutline,
    GlobeEuropeAfricaIcon as GlobeEuropeAfricaIconOutline,
    HandThumbDownIcon as HandThumbDownIconOutline,
    HandThumbUpIcon as HandThumbUpIconOutline,
    HashtagIcon as HashtagIconOutline,
    HomeIcon as HomeIconOutline,
    InformationCircleIcon as InformationCircleIconOutline,
    EllipsisVerticalIcon as KebabIconOutline,
    LinkIcon as LinkIconOutline,
    LinkSlashIcon as LinkSlashIconOutline,
    ListBulletIcon as ListBulletIconOutline,
    LockClosedIcon as LockClosedIconOutline,
    LockOpenIcon as LockOpenIconOutline,
    MagnifyingGlassIcon as MagnifyingGlassIconOutline,
    MagnifyingGlassMinusIcon as MagnifyingGlassMinusIconOutline,
    MagnifyingGlassPlusIcon as MagnifyingGlassPlusIconOutline,
    MapIcon as MapIconOutline,
    MicrophoneIcon as MicrophoneIconOutline,
    MinusCircleIcon as MinusCircleIconOutline,
    MinusIcon as MinusIconOutline,
    PaperAirplaneIcon as PaperAirplaneIconOutline,
    PaperClipIcon as PaperClipIconOutline,
    PencilIcon as PencilIconOutline,
    PencilSquareIcon as PencilSquareIconOutline,
    PhotoIcon as PhotoIconOutline,
    PlusCircleIcon as PlusCircleIconOutline,
    PlusIcon as PlusIconOutline,
    QuestionMarkCircleIcon as QuestionMarkCircleIconOutline,
    ScaleIcon as ScaleIconOutline,
    ShareIcon as ShareIconOutline,
    SparklesIcon as SparklesIconOutline,
    StarIcon as StarIconOutline,
    StopIcon as StopIconOutline,
    SunIcon as SunIconOutline,
    TrashIcon as TrashIconOutline,
    TrophyIcon as TrophyIconOutline,
    ArrowUpTrayIcon as UploadIconOutline,
    UserCircleIcon as UserCircleIconOutline,
    UserGroupIcon as UserGroupIconOutline,
    UserIcon as UserIconOutline,
    XCircleIcon as XCircleIconOutline,
    XMarkIcon as XMarkIconOutline,
} from '@heroicons/vue/24/outline'
import {
    ArrowDownIcon as ArrowDownIconSolid,
    ArrowDownRightIcon as ArrowDownRightIconSolid,
    ArrowPathIcon as ArrowPathIconSolid,
    ArrowRightIcon as ArrowRightIconSolid,
    ArrowTopRightOnSquareIcon as ArrowTopRightOnSquareIconSolid,
    ArrowTrendingUpIcon as ArrowTrendingUpIconSolid,
    ArrowUpIcon as ArrowUpIconSolid,
    ArrowUpRightIcon as ArrowUpRightIconSolid,
    BanknotesIcon as BanknotesIconSolid,
    Bars3Icon as Bars3IconSolid,
    BeakerIcon as BeakerIconSolid,
    BellIcon as BellIconSolid,
    BoltIcon as BoltIconSolid,
    BriefcaseIcon as BriefcaseIconSolid,
    BuildingOfficeIcon as BuildingOfficeIconSolid,
    CalendarIcon as CalendarSolid,
    ChatBubbleLeftIcon as ChatBubbleLeftIconSolid,
    ChatBubbleOvalLeftIcon as ChatBubbleOvalLeftIconSolid,
    CheckBadgeIcon as CheckBadgeIconSolid,
    CheckCircleIcon as CheckCircleIconSolid,
    CheckIcon as CheckIconSolid,
    ChevronDownIcon as ChevronDownIconSolid,
    ChevronLeftIcon as ChevronLeftIconSolid,
    ChevronRightIcon as ChevronRightIconSolid,
    ChevronUpDownIcon as ChevronUpDownIconSolid,
    ChevronUpIcon as ChevronUpIconSolid,
    CircleStackIcon as CircleStackIconSolid,
    ClockIcon as ClockIconSolid,
    ClipboardDocumentCheckIcon as ClipboardDocumentCheckIconSolid,
    ClipboardDocumentListIcon as ClipboardDocumentListIconSolid,
    ClipboardIcon as ClipboardIconSolid,
    Cog6ToothIcon as Cog6ToothIconSolid,
    DocumentChartBarIcon as DocumentChartBarIconSolid,
    DocumentDuplicateIcon as DocumentDuplicateIconSolid,
    DocumentIcon as DocumentIconSolid,
    DocumentMagnifyingGlassIcon as DocumentMagnifyingGlassIconSolid,
    ArrowDownTrayIcon as DownloadIconSolid,
    EnvelopeIcon as EnvelopeIconSolid,
    ExclamationCircleIcon as ExclamationCircleIconSolid,
    ExclamationTriangleIcon as ExclamationTriangleIconSolid,
    EyeIcon as EyeSolid,
    FlagIcon as FlagIconSolid,
    GlobeAltIcon as GlobeAltIconSolid,
    GlobeAmericasIcon as GlobeAmericasIconSolid,
    GlobeAsiaAustraliaIcon as GlobeAsiaAustraliaIconSolid,
    GlobeEuropeAfricaIcon as GlobeEuropeAfricaIconSolid,
    HandThumbDownIcon as HandThumbDownIconSolid,
    HandThumbUpIcon as HandThumbUpIconSolid,
    HashtagIcon as HashtagIconSolid,
    InformationCircleIcon as InformationCircleIconSolid,
    EllipsisVerticalIcon as KebabIconSolid,
    LinkIcon as LinkIconSolid,
    LinkSlashIcon as LinkSlashIconSolid,
    ListBulletIcon as ListBulletIconSolid,
    LockClosedIcon as LockClosedIconSolid,
    LockOpenIcon as LockOpenIconSolid,
    MagnifyingGlassIcon as MagnifyingGlassIconSolid,
    MagnifyingGlassMinusIcon as MagnifyingGlassMinusIconSolid,
    MagnifyingGlassPlusIcon as MagnifyingGlassPlusIconSolid,
    MapIcon as MapIconSolid,
    MicrophoneIcon as MicrophoneIconSolid,
    MinusCircleIcon as MinusCircleIconSolid,
    MinusIcon as MinusIconSolid,
    PaperAirplaneIcon as PaperAirplaneIconSolid,
    PaperClipIcon as PaperClipIconSolid,
    PencilIcon as PencilIconSolid,
    PencilSquareIcon as PencilSquareIconSolid,
    PhotoIcon as PhotoIconSolid,
    PlusCircleIcon as PlusCircleIconSolid,
    PlusIcon as PlusIconSolid,
    QuestionMarkCircleIcon as QuestionMarkCircleSolid,
    ScaleIcon as ScaleIconSolid,
    ShareIcon as ShareIconSolid,
    SparklesIcon as SparklesIconSolid,
    StarIcon as StarIconSolid,
    StopIcon as StopIconSolid,
    SunIcon as SunIconSolid,
    TrashIcon as TrashIconSolid,
    TrophyIcon as TrophyIconSolid,
    ArrowUpTrayIcon as UploadIconSolid,
    UserCircleIcon as UserCircleIconSolid,
    UserGroupIcon as UserGroupIconSolid,
    UserIcon as UserIconSolid,
    XCircleIcon as XCircleIconSolid,
    XMarkIcon as XMarkIconSolid,
} from '@heroicons/vue/24/solid'
import { createMultipleIconVariants, createSingleIconVariants } from '../helpers/iconVariants'

export const heroIcons = {
    'arrow-down': createMultipleIconVariants({ solid: ArrowDownIconSolid, outline: ArrowDownIconOutline, mini: ArrowDownIconMini, micro: ArrowDownIconMicro }),
    'arrow-down-right': createMultipleIconVariants({ solid: ArrowDownRightIconSolid, outline: ArrowDownRightIconOutline, mini: ArrowDownRightIconMini, micro: ArrowDownRightIconMicro }),
    'arrow-path': createMultipleIconVariants({ solid: ArrowPathIconSolid, outline: ArrowPathIconOutline, mini: ArrowPathIconMini, micro: ArrowPathIconMicro }),
    'arrow-right': createMultipleIconVariants({ solid: ArrowRightIconSolid, outline: ArrowRightIconOutline, mini: ArrowRightIconMini, micro: ArrowRightIconMicro }),
    'arrow-up': createMultipleIconVariants({ solid: ArrowUpIconSolid, outline: ArrowUpIconOutline, mini: ArrowUpIconMini, micro: ArrowUpIconMicro }),
    'arrow-up-right': createMultipleIconVariants({ solid: ArrowUpRightIconSolid, outline: ArrowUpRightIconOutline, mini: ArrowUpRightIconMini, micro: ArrowUpRightIconMicro }),
    'arrow-top-right-on-square': createMultipleIconVariants({ solid: ArrowTopRightOnSquareIconSolid, outline: ArrowTopRightOnSquareIconOutline, mini: ArrowTopRightOnSquareIconOutline, micro: ArrowTopRightOnSquareIconOutline }),
    'arrow-trending-up': createMultipleIconVariants({ solid: ArrowTrendingUpIconSolid, outline: ArrowTrendingUpIconOutline, mini: ArrowTrendingUpIconMini, micro: ArrowTrendingUpIconMicro }),
    'banknotes': createMultipleIconVariants({ solid: BanknotesIconSolid, outline: BanknotesIconOutline, mini: BanknotesIconMini, micro: BanknotesIconMicro }),
    'bars-3': createMultipleIconVariants({ solid: Bars3IconSolid, outline: Bars3IconOutline, mini: Bars3IconMini, micro: Bars3IconMicro }),
    'bell': createMultipleIconVariants({ solid: BellIconSolid, outline: BellIconOutline, mini: BellIconMini, micro: BellIconMicro }),
    'briefcase': createMultipleIconVariants({ solid: BriefcaseIconSolid, outline: BriefcaseIconOutline, mini: BriefcaseIconMini, micro: BriefcaseIconMicro }),
    'building-office': createMultipleIconVariants({ solid: BuildingOfficeIconSolid, outline: BuildingOfficeIconOutline, mini: BuildingOfficeIconMini, micro: BuildingOfficeIconMicro }),
    'building-office-outline': createSingleIconVariants(BuildingOfficeIconOutline),
    'calendar': createMultipleIconVariants({ solid: CalendarSolid, outline: CalendarOutline, mini: CalendarMini, micro: CalendarMicro }),
    'certificates': createMultipleIconVariants({ solid: CheckBadgeIconSolid, outline: CheckBadgeIconOutline, mini: CheckBadgeIconMini, micro: CheckBadgeIconMicro }),
    'chart-bar-square': createSingleIconVariants(ChartBarSquareIconOutline),
    'chart-bar': createSingleIconVariants(ChartBarIconOutline),
    'chart-pie': createSingleIconVariants(ChartPieIconOutline),
    'chat': createMultipleIconVariants({ solid: ChatBubbleOvalLeftIconSolid, outline: ChatBubbleOvalLeftIconOutline, mini: ChatBubbleOvalLeftIconMini, micro: ChatBubbleOvalLeftIconMicro }),
    'chat-bubble-left': createMultipleIconVariants({ solid: ChatBubbleLeftIconSolid, outline: ChatBubbleLeftIconOutline, mini: ChatBubbleLeftIconMini, micro: ChatBubbleLeftIconMicro }),
    'chat-outline': createSingleIconVariants(ChatBubbleOvalLeftIconOutline),
    'check-circle': createMultipleIconVariants({ solid: CheckCircleIconSolid, outline: CheckCircleIconOutline, mini: CheckCircleIconMini, micro: CheckCircleIconMicro }),
    'check': createMultipleIconVariants({ solid: CheckIconSolid, outline: CheckIconOutline, mini: CheckIconMini, micro: CheckIconMicro }),
    'chevron-down': createMultipleIconVariants({ solid: ChevronDownIconSolid, outline: ChevronDownIconOutline, mini: ChevronDownIconMini, micro: ChevronDownIconMicro }),
    'chevron-left': createMultipleIconVariants({ solid: ChevronLeftIconSolid, outline: ChevronLeftIconOutline, mini: ChevronLeftIconMini, micro: ChevronLeftIconMicro }),
    'chevron-right': createMultipleIconVariants({ solid: ChevronRightIconSolid, outline: ChevronRightIconOutline, mini: ChevronRightIconMini, micro: ChevronRightIconMicro }),
    'chevron-up': createMultipleIconVariants({ solid: ChevronUpIconSolid, outline: ChevronUpIconOutline, mini: ChevronUpIconMini, micro: ChevronUpIconMicro }),
    'chevron-up-down': createMultipleIconVariants({ solid: ChevronUpDownIconSolid, outline: ChevronUpDownIconOutline, mini: ChevronUpDownIconMini, micro: ChevronUpDownIconMicro }),
    'circle-stack': createMultipleIconVariants({ solid: CircleStackIconOutline, outline: CircleStackIconOutline, mini: CircleStackIconOutline, micro: CircleStackIconMicro }),
    'clock': createMultipleIconVariants({ solid: ClockIconSolid, outline: ClockIconOutline, mini: ClockIconMini, micro: ClockIconMicro }),
    'clipboard-document-check': createMultipleIconVariants({ solid: ClipboardDocumentCheckIconSolid, outline: ClipboardDocumentCheckIconOutline, mini: ClipboardDocumentCheckIconMini, micro: ClipboardDocumentCheckIconMicro }),
    'clipboard-document-list': createMultipleIconVariants({ solid: ClipboardDocumentListIconSolid, outline: ClipboardDocumentListIconOutline, mini: ClipboardDocumentListIconMini, micro: ClipboardDocumentListIconMicro }),
    'clipboard': createMultipleIconVariants({ solid: ClipboardIconSolid, outline: ClipboardIconOutline, mini: ClipboardIconMini, micro: ClipboardIconMicro }),
    'close': createMultipleIconVariants({ solid: XMarkIconSolid, outline: XMarkIconOutline, mini: XMarkIconMini, micro: XMarkIconMicro }),
    'document': createMultipleIconVariants({ solid: DocumentIconSolid, outline: DocumentIconOutline, mini: DocumentIconOutline, micro: DocumentIconOutline }), // use outline verison for mini and micro sizes
    'document-chart-bar': createMultipleIconVariants({ solid: DocumentChartBarIconSolid, outline: DocumentChartBarIconOutline, mini: DocumentChartBarIconMini, micro: DocumentChartBarIconMicro }),
    'document-duplicate': createMultipleIconVariants({ solid: DocumentDuplicateIconSolid, outline: DocumentDuplicateIconOutline, mini: DocumentDuplicateIconMini, micro: DocumentDuplicateIconMicro }),
    'document-magnifying-glass': createMultipleIconVariants({ solid: DocumentMagnifyingGlassIconSolid, outline: DocumentMagnifyingGlassIconOutline, mini: DocumentMagnifyingGlassIconMini, micro: DocumentMagnifyingGlassIconMicro }),
    'download': createMultipleIconVariants({ solid: DownloadIconSolid, outline: DownloadIconOutline, mini: DownloadIconMini, micro: DownloadIconMicro }),
    'envelope': createMultipleIconVariants({ solid: EnvelopeIconSolid, outline: EnvelopeIconOutline, mini: EnvelopeIconMini, micro: EnvelopeIconMicro }),
    'esg-emissions': createMultipleIconVariants({ solid: BeakerIconSolid, outline: BeakerIconOutline, mini: BeakerIconMini, micro: BeakerIconMicro }),
    'esg-energy': createMultipleIconVariants({ solid: BoltIconSolid, outline: BoltIconOutline, mini: BoltIconMini, micro: BoltIconMicro }),
    'exclamation-circle': createMultipleIconVariants({ solid: ExclamationCircleIconSolid, outline: ExclamationCircleIconOutline, mini: ExclamationCircleIconMini, micro: ExclamationCircleIconMicro }),
    'exclamation-triangle': createMultipleIconVariants({ solid: ExclamationTriangleIconSolid, outline: ExclamationTriangleIconOutline, mini: ExclamationTriangleIconMini, micro: ExclamationTriangleIconMicro }),
    'eye': createMultipleIconVariants({ solid: EyeSolid, outline: EyeOutline, mini: EyeMini, micro: EyeMicro }),
    'flag': createMultipleIconVariants({ solid: FlagIconSolid, outline: FlagIconOutline, mini: FlagIconMini, micro: FlagIconMicro }),
    'funnel-outline': createSingleIconVariants(FunnelIconOutline),
    'globe-alt': createMultipleIconVariants({ solid: GlobeAltIconSolid, outline: GlobeAltIconOutline, mini: GlobeAltIconMini, micro: GlobeAltIconMicro }),
    'globe-americas': createMultipleIconVariants({ solid: GlobeAmericasIconSolid, outline: GlobeAmericasIconOutline, mini: GlobeAmericasIconMini, micro: GlobeAmericasIconMicro }),
    'globe-asia-australia': createMultipleIconVariants({ solid: GlobeAsiaAustraliaIconSolid, outline: GlobeAsiaAustraliaIconOutline, mini: GlobeAsiaAustraliaIconMini, micro: GlobeAsiaAustraliaIconMicro }),
    'globe-europe-africa': createMultipleIconVariants({ solid: GlobeEuropeAfricaIconSolid, outline: GlobeEuropeAfricaIconOutline, mini: GlobeEuropeAfricaIconMini, micro: GlobeEuropeAfricaIconMicro }),
    'home': createSingleIconVariants(HomeIconOutline),
    'information-circle': createMultipleIconVariants({ solid: InformationCircleIconSolid, outline: InformationCircleIconOutline, mini: InformationCircleIconMini, micro: InformationCircleIconMicro }),
    'kebab': createMultipleIconVariants({ solid: KebabIconSolid, outline: KebabIconOutline, mini: KebabIconMini, micro: KebabIconMicro }),
    'lock-closed': createMultipleIconVariants({ solid: LockClosedIconSolid, outline: LockClosedIconOutline, mini: LockClosedIconMini, micro: LockClosedIconMicro }),
    'lock-open': createMultipleIconVariants({ solid: LockOpenIconSolid, outline: LockOpenIconOutline, mini: LockOpenIconMini, micro: LockOpenIconMicro }),
    'link': createMultipleIconVariants({ solid: LinkIconSolid, outline: LinkIconOutline, mini: LinkIconMini, micro: LinkIconMicro }),
    'link-slash': createMultipleIconVariants({ solid: LinkSlashIconSolid, outline: LinkSlashIconOutline, mini: LinkSlashIconMini, micro: LinkSlashIconMicro }),
    'list-bullet': createMultipleIconVariants({ solid: ListBulletIconSolid, outline: ListBulletIconOutline, mini: ListBulletIconMini, micro: ListBulletIconMicro }),
    'magnifying-glass': createMultipleIconVariants({ solid: MagnifyingGlassIconSolid, outline: MagnifyingGlassIconOutline, mini: MagnifyingGlassIconMini, micro: MagnifyingGlassIconMicro }),
    'magnifying-glass-minus': createMultipleIconVariants({ solid: MagnifyingGlassMinusIconSolid, outline: MagnifyingGlassMinusIconOutline, mini: MagnifyingGlassMinusIconMini, micro: MagnifyingGlassMinusIconMicro }),
    'magnifying-glass-plus': createMultipleIconVariants({ solid: MagnifyingGlassPlusIconSolid, outline: MagnifyingGlassPlusIconOutline, mini: MagnifyingGlassPlusIconMini, micro: MagnifyingGlassPlusIconMicro }),
    'map': createMultipleIconVariants({ solid: MapIconSolid, outline: MapIconOutline, mini: MapIconMini, micro: MapIconMicro }),
    'microphone': createMultipleIconVariants({ solid: MicrophoneIconSolid, outline: MicrophoneIconOutline, mini: MicrophoneIconMini, micro: MicrophoneIconMicro }),
    'minus': createMultipleIconVariants({ solid: MinusIconSolid, outline: MinusIconOutline, mini: MinusIconMini, micro: MinusIconMicro }),
    'minus-circle': createMultipleIconVariants({ solid: MinusCircleIconSolid, outline: MinusCircleIconOutline, mini: MinusCircleIconMini, micro: MinusCircleIconMicro }),
    'paper-airplane': createMultipleIconVariants({ solid: PaperAirplaneIconSolid, outline: PaperAirplaneIconOutline, mini: PaperAirplaneIconMini, micro: PaperAirplaneIconMicro }),
    'paper-clip': createMultipleIconVariants({ solid: PaperClipIconSolid, outline: PaperClipIconOutline, mini: PaperClipIconMini, micro: PaperClipIconMicro }),
    'pencil-outline': createSingleIconVariants(PencilIconOutline),
    'pencil': createMultipleIconVariants({ solid: PencilIconSolid, outline: PencilIconOutline, mini: PencilIconMini, micro: PencilIconMicro }),
    'pencil-square': createMultipleIconVariants({ solid: PencilSquareIconSolid, outline: PencilSquareIconOutline, mini: PencilSquareIconMini, micro: PencilSquareIconMicro }),
    'plus': createMultipleIconVariants({ solid: PlusIconSolid, outline: PlusIconOutline, mini: PlusIconMini, micro: PlusIconMicro }),
    'plus-circle': createMultipleIconVariants({ solid: PlusCircleIconSolid, outline: PlusCircleIconOutline, mini: PlusCircleIconMini, micro: PlusCircleIconMicro }),
    'question-mark-circle': createMultipleIconVariants({ solid: QuestionMarkCircleSolid, outline: QuestionMarkCircleIconOutline, mini: QuestionMarkCircleMini, micro: QuestionMarkCircleMicro }),
    'scale': createMultipleIconVariants({ solid: ScaleIconSolid, outline: ScaleIconOutline, mini: ScaleIconMini, micro: ScaleIconMicro }),
    'settings': createMultipleIconVariants({ solid: Cog6ToothIconSolid, outline: Cog6ToothIconOutline, mini: Cog6ToothIconMini, micro: Cog6ToothIconMicro }),
    'sparkles': createMultipleIconVariants({ solid: SparklesIconSolid, outline: SparklesIconOutline, mini: SparklesIconMini, micro: SparklesIconMicro }),
    'star': createMultipleIconVariants({ solid: StarIconSolid, outline: StarIconOutline, mini: StarIconMini, micro: StarIconMicro }),
    'stop': createMultipleIconVariants({ solid: StopIconSolid, outline: StopIconOutline, mini: StopIconMini, micro: StopIconMicro }),
    'sun': createMultipleIconVariants({ solid: SunIconSolid, outline: SunIconOutline, mini: SunIconMini, micro: SunIconMicro }),
    'tenant': createMultipleIconVariants({ solid: UserIconSolid, outline: UserIconOutline, mini: UserIconMini, micro: UserIconMicro }),
    'trash': createMultipleIconVariants({ solid: TrashIconSolid, outline: TrashIconOutline, mini: TrashIconMini, micro: TrashIconMicro }),
    'trophy': createMultipleIconVariants({ solid: TrophyIconSolid, outline: TrophyIconOutline, mini: TrophyIconMini, micro: TrophyIconMicro }),
    'upload': createMultipleIconVariants({ solid: UploadIconSolid, outline: UploadIconOutline, mini: UploadIconMini, micro: UploadIconMicro }),
    'user-circle': createMultipleIconVariants({ solid: UserCircleIconSolid, outline: UserCircleIconOutline, mini: UserCircleIconMini, micro: UserCircleIconMicro }),
    'user-group': createMultipleIconVariants({ solid: UserGroupIconSolid, outline: UserGroupIconOutline, mini: UserGroupIconMini, micro: UserGroupIconMicro }),
    'x-circle': createMultipleIconVariants({ solid: XCircleIconSolid, outline: XCircleIconOutline, mini: XCircleIconMini, micro: XCircleIconMicro }),
    'thumb-up': createMultipleIconVariants({ solid: HandThumbUpIconSolid, outline: HandThumbUpIconOutline, mini: HandThumbUpIconMini, micro: HandThumbUpIconMicro }),
    'thumb-down': createMultipleIconVariants({ solid: HandThumbDownIconSolid, outline: HandThumbDownIconOutline, mini: HandThumbDownIconMini, micro: HandThumbDownIconMicro }),
    'thumb-up-outline': createSingleIconVariants(HandThumbUpIconOutline),
    'thumb-down-outline': createSingleIconVariants(HandThumbDownIconOutline),
    'thumb-up-solid': createSingleIconVariants(HandThumbUpIconSolid),
    'thumb-down-solid': createSingleIconVariants(HandThumbDownIconSolid),
    'information-circle-outline': createSingleIconVariants(InformationCircleIconOutline),
    'hashtag': createMultipleIconVariants({ solid: HashtagIconSolid, outline: HashtagIconOutline, mini: HashtagIconMini, micro: HashtagIconMicro }),
    'share': createMultipleIconVariants({ solid: ShareIconSolid, outline: ShareIconOutline, mini: ShareIconMini, micro: ShareIconMicro }),
    'photo': createMultipleIconVariants({ solid: PhotoIconSolid, outline: PhotoIconOutline, mini: PhotoIconMini, micro: PhotoIconMicro }),
}
